import Stack from 'atoms/Layout/Stack/Stack';
import { cssVar } from 'src/app/styles/helper';
import styled from 'styled-components';

export const TableOfContentsStack = styled(Stack)`
  position: sticky;
  top: 100px;
  height: fit-content;
  overflow-y: auto;
  max-height: calc(100vh - 120px);
  flex: 1 0 280px;
`;

export const TableOfContentsStackContent = styled(Stack)`
  border-top: 1px solid ${cssVar('border-secondary')};
  border-bottom: 1px solid ${cssVar('border-secondary')};
`;

export const TableOfContentsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const TableOfContentsListItem = styled.li`
  .link-button {
    padding: ${cssVar('spacing-md')} 0;
    justify-content: flex-start;
    color: ${cssVar('text-tertiary')};
    position: relative;

    &.active {
      color: ${cssVar('text-primary')};
      font-weight: ${cssVar('font-weight-semibold')};
    }

    &:focus {
      box-shadow: none;
    }
  }
`;

export const TableOfContentsSubList = styled.ul`
  list-style: none;
`;

export const ArticleWithTableOfContentsSocialStack = styled(Stack)`
  .social-button {
    width: fit-content;
  }
`;
